import { type TrackingConsentDetails } from '@transcend-io/airgap.js-types';

import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';

export function useConsentTracking() {
  const { sendActivityTrackerEvent } = useActivityTracker();

  function sendCookieBannerViewEvent(transitionFrom: string) {
    sendActivityTrackerEvent(ActivityTrackerEventType.COOKIE_BANNER_VIEW, {
      transitionFrom,
      schemaVersion: '4.0',
      bannerProvider: 'transcend',
    });
  }

  function sendAcceptAllEvent() {
    sendActivityTrackerEvent(ActivityTrackerEventType.COOKIE_BANNER_ACCEPT);
  }

  function sendRejectAllEvent() {
    sendActivityTrackerEvent(ActivityTrackerEventType.COOKIE_BANNER_REJECT, {
      schemaVersion: '1.0',
    });
  }

  function sendCookieModalManageEvent() {
    sendActivityTrackerEvent(ActivityTrackerEventType.COOKIE_BANNER_MANAGE);
  }

  function sendCookieModalActionEvent(consent: TrackingConsentDetails) {
    sendActivityTrackerEvent(ActivityTrackerEventType.COOKIE_MODAL_ACTION, {
      functionalCookies: consent?.purposes?.Functional,
      analyticsCookies: consent?.purposes?.Analytics,
      socialCookies: consent?.purposes?.Advertising,
      actionType: 'accept',
    });
  }

  return {
    sendCookieBannerViewEvent,
    sendAcceptAllEvent,
    sendRejectAllEvent,
    sendCookieModalActionEvent,
    sendCookieModalManageEvent,
  };
}
